import { c as _c } from "react/compiler-runtime";
// Карточка магазина-черновика: что модель поняла о магазине из материалов.
// Загрузка создаст по ней магазин и анкету «О магазине»; логотип и обложка —
// из картинок задания.
import { ChevronDown, ChevronRight, ImagePlus, Loader2, X } from "lucide-react";
import { useState } from "react";
import type { CatalogImportFile, CatalogImportJobDetail, CatalogImportShopDraft } from "@osmix/contracts";
import { useUpdateImportJob } from "@/api/hooks/use-catalog-import";
import { Button } from "@osmix/ui/button";
import { Input } from "@osmix/ui/input";
import { cn } from "@/lib/utils";
import { useCategoryLeaves } from "./category-select";
import { ImagePicker } from "./image-picker";
import { ImportThumb, errorText } from "./shared";
const SOCIALS: {
  key: keyof CatalogImportShopDraft["socials"];
  label: string;
  placeholder: string;
}[] = [{
  key: "website",
  label: "Сайт",
  placeholder: "example.ru"
}, {
  key: "telegram",
  label: "Telegram",
  placeholder: "t.me/…"
}, {
  key: "vk",
  label: "ВКонтакте",
  placeholder: "vk.com/…"
}, {
  key: "instagram",
  label: "Instagram",
  placeholder: "instagram.com/…"
}, {
  key: "youtube",
  label: "YouTube",
  placeholder: "youtube.com/…"
}, {
  key: "rutube",
  label: "Rutube",
  placeholder: "rutube.ru/…"
}, {
  key: "tiktok",
  label: "TikTok",
  placeholder: "tiktok.com/@…"
}, {
  key: "other",
  label: "Другое",
  placeholder: "Ссылка"
}];
const EMPTY: CatalogImportShopDraft = {
  shopName: "",
  brandDescription: "",
  mainProduct: "",
  city: "",
  categories: [],
  socials: {
    website: "",
    instagram: "",
    vk: "",
    telegram: "",
    youtube: "",
    rutube: "",
    tiktok: "",
    other: ""
  }
};
const textareaClass = "min-h-24 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-60 md:text-sm";
export function ShopDraftCard(t0) {
  const $ = _c(135);
  const {
    job,
    editable
  } = t0;
  const t1 = job.shopDraft?.socials;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      ...EMPTY.socials,
      ...t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== job.shopDraft || $[3] !== t2) {
    t3 = {
      ...EMPTY,
      ...job.shopDraft,
      socials: t2
    };
    $[2] = job.shopDraft;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const server = t3;
  const [draft, setDraft] = useState(server);
  const [more, setMore] = useState(false);
  const [picking, setPicking] = useState(null);
  const [message, setMessage] = useState(null);
  const update = useUpdateImportJob(job.id);
  const {
    roots
  } = useCategoryLeaves();
  const dirty = JSON.stringify(draft) !== JSON.stringify(server);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (key, value) => {
      setMessage(null);
      setDraft(d => ({
        ...d,
        [key]: value
      }));
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const set = t4;
  let t5;
  if ($[6] !== draft || $[7] !== update) {
    t5 = async () => {
      setMessage(null);
      ;
      try {
        await update.mutateAsync({
          shopDraft: draft
        });
        setMessage({
          ok: true,
          text: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E"
        });
      } catch (t6) {
        const e = t6;
        setMessage({
          ok: false,
          text: errorText(e)
        });
      }
    };
    $[6] = draft;
    $[7] = update;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const save = t5;
  let t6;
  if ($[9] !== job.files) {
    t6 = id => job.files.find(f => f.id === id);
    $[9] = job.files;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const fileOf = t6;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t7;
  let t8;
  let t9;
  if ($[11] !== dirty || $[12] !== draft.brandDescription || $[13] !== draft.categories || $[14] !== draft.city || $[15] !== draft.mainProduct || $[16] !== draft.shopName || $[17] !== editable || $[18] !== message || $[19] !== roots || $[20] !== save || $[21] !== server || $[22] !== update) {
    const sections = [...new Set([...roots, ...draft.categories])];
    t18 = "rounded-lg border";
    let t20;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <div className="min-w-0"><h2 className="font-semibold">Магазин</h2><p className="text-xs text-muted-foreground">Загрузка создаст магазин с этой анкетой. Продавец сможет поправить её в кабинете.</p></div>;
      $[36] = t20;
    } else {
      t20 = $[36];
    }
    let t21;
    if ($[37] !== dirty || $[38] !== editable || $[39] !== save || $[40] !== server || $[41] !== update) {
      t21 = editable && dirty && <div className="flex gap-2"><Button variant="outline" size="sm" onClick={() => setDraft(server)} disabled={update.isPending}>Отменить</Button><Button size="sm" onClick={() => void save()} disabled={update.isPending}>{update.isPending && <Loader2 className="size-4 animate-spin" />}Сохранить магазин</Button></div>;
      $[37] = dirty;
      $[38] = editable;
      $[39] = save;
      $[40] = server;
      $[41] = update;
      $[42] = t21;
    } else {
      t21 = $[42];
    }
    let t22;
    if ($[43] !== dirty || $[44] !== message) {
      t22 = message && !dirty && <span className={cn("text-xs", message.ok ? "text-muted-foreground" : "text-destructive")}>{message.text}</span>;
      $[43] = dirty;
      $[44] = message;
      $[45] = t22;
    } else {
      t22 = $[45];
    }
    if ($[46] !== t21 || $[47] !== t22) {
      t19 = <div className="flex flex-wrap items-center justify-between gap-2 border-b px-4 py-3">{t20}{t21}{t22}</div>;
      $[46] = t21;
      $[47] = t22;
      $[48] = t19;
    } else {
      t19 = $[48];
    }
    t16 = !editable;
    t17 = "grid gap-4 p-4 lg:grid-cols-[minmax(0,1fr)_260px]";
    t11 = "grid min-w-0 gap-3 sm:grid-cols-2";
    const t23 = !draft.shopName.trim();
    const t24 = !draft.shopName.trim() || undefined;
    let t25;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = e_0 => set("shopName", e_0.target.value);
      $[49] = t25;
    } else {
      t25 = $[49];
    }
    let t26;
    if ($[50] !== draft.shopName || $[51] !== t24) {
      t26 = <Input id="sd-name" value={draft.shopName} aria-invalid={t24} onChange={t25} />;
      $[50] = draft.shopName;
      $[51] = t24;
      $[52] = t26;
    } else {
      t26 = $[52];
    }
    if ($[53] !== t23 || $[54] !== t26) {
      t12 = <Field label={"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430"} htmlFor="sd-name" invalid={t23}>{t26}</Field>;
      $[53] = t23;
      $[54] = t26;
      $[55] = t12;
    } else {
      t12 = $[55];
    }
    let t27;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t27 = e_1 => set("city", e_1.target.value);
      $[56] = t27;
    } else {
      t27 = $[56];
    }
    if ($[57] !== draft.city) {
      t13 = <Field label={"\u0413\u043E\u0440\u043E\u0434"} htmlFor="sd-city"><Input id="sd-city" value={draft.city} onChange={t27} /></Field>;
      $[57] = draft.city;
      $[58] = t13;
    } else {
      t13 = $[58];
    }
    let t28;
    if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = e_2 => set("mainProduct", e_2.target.value);
      $[59] = t28;
    } else {
      t28 = $[59];
    }
    if ($[60] !== draft.mainProduct) {
      t14 = <Field label={"\u0413\u043B\u0430\u0432\u043D\u044B\u0439 \u0442\u043E\u0432\u0430\u0440"} htmlFor="sd-main" className="sm:col-span-2"><Input id="sd-main" value={draft.mainProduct} onChange={t28} placeholder={"\u0427\u0435\u043C \u043C\u0430\u0433\u0430\u0437\u0438\u043D \u0438\u0437\u0432\u0435\u0441\u0442\u0435\u043D: \xAB\u043B\u044C\u043D\u044F\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u044C\u044F\xBB"} /></Field>;
      $[60] = draft.mainProduct;
      $[61] = t14;
    } else {
      t14 = $[61];
    }
    let t29;
    if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
      t29 = e_3 => set("brandDescription", e_3.target.value);
      $[62] = t29;
    } else {
      t29 = $[62];
    }
    if ($[63] !== draft.brandDescription) {
      t15 = <Field label={"\u041E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435"} htmlFor="sd-about" className="sm:col-span-2"><textarea id="sd-about" value={draft.brandDescription} onChange={t29} className={textareaClass} /></Field>;
      $[63] = draft.brandDescription;
      $[64] = t15;
    } else {
      t15 = $[64];
    }
    t9 = "space-y-1.5 sm:col-span-2";
    if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <span className="text-sm font-medium">Разделы каталога</span>;
      $[65] = t10;
    } else {
      t10 = $[65];
    }
    t7 = "flex flex-wrap gap-2";
    t8 = sections.map(name => {
      const on = draft.categories.includes(name);
      return <button key={name} type="button" aria-pressed={on} onClick={() => set("categories", on ? draft.categories.filter(c => c !== name) : [...draft.categories, name])} className={cn("rounded-full border px-3 py-1 text-sm transition-colors disabled:opacity-60", on ? "border-primary bg-primary/10" : "hover:bg-muted/60")}>{name}</button>;
    });
    $[11] = dirty;
    $[12] = draft.brandDescription;
    $[13] = draft.categories;
    $[14] = draft.city;
    $[15] = draft.mainProduct;
    $[16] = draft.shopName;
    $[17] = editable;
    $[18] = message;
    $[19] = roots;
    $[20] = save;
    $[21] = server;
    $[22] = update;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
  } else {
    t10 = $[23];
    t11 = $[24];
    t12 = $[25];
    t13 = $[26];
    t14 = $[27];
    t15 = $[28];
    t16 = $[29];
    t17 = $[30];
    t18 = $[31];
    t19 = $[32];
    t7 = $[33];
    t8 = $[34];
    t9 = $[35];
  }
  let t20;
  if ($[66] !== t7 || $[67] !== t8) {
    t20 = <div className={t7}>{t8}</div>;
    $[66] = t7;
    $[67] = t8;
    $[68] = t20;
  } else {
    t20 = $[68];
  }
  let t21;
  if ($[69] !== t10 || $[70] !== t20 || $[71] !== t9) {
    t21 = <div className={t9}>{t10}{t20}</div>;
    $[69] = t10;
    $[70] = t20;
    $[71] = t9;
    $[72] = t21;
  } else {
    t21 = $[72];
  }
  let t22;
  if ($[73] !== t11 || $[74] !== t12 || $[75] !== t13 || $[76] !== t14 || $[77] !== t15 || $[78] !== t21) {
    t22 = <div className={t11}>{t12}{t13}{t14}{t15}{t21}</div>;
    $[73] = t11;
    $[74] = t12;
    $[75] = t13;
    $[76] = t14;
    $[77] = t15;
    $[78] = t21;
    $[79] = t22;
  } else {
    t22 = $[79];
  }
  const t23 = job.id;
  let t24;
  if ($[80] !== draft.logoFileId || $[81] !== fileOf) {
    t24 = fileOf(draft.logoFileId);
    $[80] = draft.logoFileId;
    $[81] = fileOf;
    $[82] = t24;
  } else {
    t24 = $[82];
  }
  let t25;
  let t26;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => setPicking("logo");
    t26 = () => set("logoFileId", null);
    $[83] = t25;
    $[84] = t26;
  } else {
    t25 = $[83];
    t26 = $[84];
  }
  let t27;
  if ($[85] !== editable || $[86] !== job.id || $[87] !== t24) {
    t27 = <ImageSlot label={"\u041B\u043E\u0433\u043E\u0442\u0438\u043F"} jobId={t23} file={t24} editable={editable} square={true} onPick={t25} onClear={t26} />;
    $[85] = editable;
    $[86] = job.id;
    $[87] = t24;
    $[88] = t27;
  } else {
    t27 = $[88];
  }
  const t28 = job.id;
  let t29;
  if ($[89] !== draft.coverFileId || $[90] !== fileOf) {
    t29 = fileOf(draft.coverFileId);
    $[89] = draft.coverFileId;
    $[90] = fileOf;
    $[91] = t29;
  } else {
    t29 = $[91];
  }
  let t30;
  let t31;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = () => setPicking("cover");
    t31 = () => set("coverFileId", null);
    $[92] = t30;
    $[93] = t31;
  } else {
    t30 = $[92];
    t31 = $[93];
  }
  let t32;
  if ($[94] !== editable || $[95] !== job.id || $[96] !== t29) {
    t32 = <ImageSlot label={"\u041E\u0431\u043B\u043E\u0436\u043A\u0430"} jobId={t28} file={t29} editable={editable} onPick={t30} onClear={t31} />;
    $[94] = editable;
    $[95] = job.id;
    $[96] = t29;
    $[97] = t32;
  } else {
    t32 = $[97];
  }
  let t33;
  if ($[98] !== t27 || $[99] !== t32) {
    t33 = <div className="grid grid-cols-2 gap-3 lg:grid-cols-1">{t27}{t32}</div>;
    $[98] = t27;
    $[99] = t32;
    $[100] = t33;
  } else {
    t33 = $[100];
  }
  let t34;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = () => setMore(_temp);
    $[101] = t34;
  } else {
    t34 = $[101];
  }
  let t35;
  if ($[102] !== more) {
    t35 = more ? <ChevronDown className="size-4" /> : <ChevronRight className="size-4" />;
    $[102] = more;
    $[103] = t35;
  } else {
    t35 = $[103];
  }
  let t36;
  if ($[104] !== more || $[105] !== t35) {
    t36 = <button type="button" onClick={t34} className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline" aria-expanded={more}>{t35}Соцсети, реквизиты и контакт</button>;
    $[104] = more;
    $[105] = t35;
    $[106] = t36;
  } else {
    t36 = $[106];
  }
  let t37;
  if ($[107] !== draft.contact || $[108] !== draft.legal || $[109] !== draft.socials || $[110] !== more) {
    t37 = more && <div className="mt-3 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">{SOCIALS.map(s => <Field key={s.key} label={s.label} htmlFor={`sd-${s.key}`}><Input id={`sd-${s.key}`} value={draft.socials[s.key]} placeholder={s.placeholder} onChange={e_4 => set("socials", {
          ...draft.socials,
          [s.key]: e_4.target.value
        })} /></Field>)}<Field label={"\u0418\u041D\u041D"} htmlFor="sd-inn"><Input id="sd-inn" inputMode="numeric" value={draft.legal?.inn ?? ""} onChange={e_5 => set("legal", {
          ...draft.legal,
          inn: e_5.target.value
        })} /></Field><Field label={"\u042E\u0440\u043B\u0438\u0446\u043E / \u0418\u041F"} htmlFor="sd-legal"><Input id="sd-legal" value={draft.legal?.fullName ?? ""} onChange={e_6 => set("legal", {
          ...draft.legal,
          fullName: e_6.target.value
        })} /></Field><Field label={"\u041A\u043E\u043D\u0442\u0430\u043A\u0442"} htmlFor="sd-contact-name"><Input id="sd-contact-name" value={draft.contact?.name ?? ""} onChange={e_7 => set("contact", {
          ...draft.contact,
          name: e_7.target.value
        })} /></Field><Field label={"\u0422\u0435\u043B\u0435\u0444\u043E\u043D"} htmlFor="sd-contact-phone"><Input id="sd-contact-phone" type="tel" value={draft.contact?.phone ?? ""} onChange={e_8 => set("contact", {
          ...draft.contact,
          phone: e_8.target.value
        })} /></Field></div>;
    $[107] = draft.contact;
    $[108] = draft.legal;
    $[109] = draft.socials;
    $[110] = more;
    $[111] = t37;
  } else {
    t37 = $[111];
  }
  let t38;
  if ($[112] !== t36 || $[113] !== t37) {
    t38 = <div className="lg:col-span-2">{t36}{t37}</div>;
    $[112] = t36;
    $[113] = t37;
    $[114] = t38;
  } else {
    t38 = $[114];
  }
  let t39;
  if ($[115] !== t16 || $[116] !== t17 || $[117] !== t22 || $[118] !== t33 || $[119] !== t38) {
    t39 = <fieldset disabled={t16} className={t17}>{t22}{t33}{t38}</fieldset>;
    $[115] = t16;
    $[116] = t17;
    $[117] = t22;
    $[118] = t33;
    $[119] = t38;
    $[120] = t39;
  } else {
    t39 = $[120];
  }
  const t40 = !!picking;
  const t41 = picking === "logo" ? "\u041B\u043E\u0433\u043E\u0442\u0438\u043F \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430" : "\u041E\u0431\u043B\u043E\u0436\u043A\u0430 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430";
  let t42;
  if ($[121] !== picking) {
    t42 = t43 => {
      const [id_0] = t43;
      if (!id_0) {
        return;
      }
      set(picking === "logo" ? "logoFileId" : "coverFileId", id_0);
    };
    $[121] = picking;
    $[122] = t42;
  } else {
    t42 = $[122];
  }
  let t43;
  if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = () => setPicking(null);
    $[123] = t43;
  } else {
    t43 = $[123];
  }
  let t44;
  if ($[124] !== job.files || $[125] !== job.id || $[126] !== t40 || $[127] !== t41 || $[128] !== t42) {
    t44 = <ImagePicker open={t40} jobId={job.id} files={job.files} multiple={false} title={t41} description={"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0443 \u0438\u0437 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0437\u0430\u0434\u0430\u043D\u0438\u044F."} confirmLabel={"\u0412\u044B\u0431\u0440\u0430\u0442\u044C"} onConfirm={t42} onClose={t43} />;
    $[124] = job.files;
    $[125] = job.id;
    $[126] = t40;
    $[127] = t41;
    $[128] = t42;
    $[129] = t44;
  } else {
    t44 = $[129];
  }
  let t45;
  if ($[130] !== t18 || $[131] !== t19 || $[132] !== t39 || $[133] !== t44) {
    t45 = <section className={t18}>{t19}{t39}{t44}</section>;
    $[130] = t18;
    $[131] = t19;
    $[132] = t39;
    $[133] = t44;
    $[134] = t45;
  } else {
    t45 = $[134];
  }
  return t45;
}
function _temp(v) {
  return !v;
}
function Field(t0) {
  const $ = _c(12);
  const {
    label,
    htmlFor,
    className,
    invalid,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("min-w-0 space-y-1.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== invalid) {
    t2 = invalid && <span className="ml-1 text-xs font-normal text-destructive">— обязательно</span>;
    $[2] = invalid;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== htmlFor || $[5] !== label || $[6] !== t2) {
    t3 = <label htmlFor={htmlFor} className="text-sm font-medium">{label}{t2}</label>;
    $[4] = htmlFor;
    $[5] = label;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== t1 || $[10] !== t3) {
    t4 = <div className={t1}>{t3}{children}</div>;
    $[8] = children;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function ImageSlot(t0) {
  const $ = _c(27);
  const {
    label,
    jobId,
    file,
    editable,
    square,
    onPick,
    onClear
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-sm font-medium">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = square && "max-w-36";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("relative", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = !editable;
  const t5 = square ? "aspect-square" : "aspect-[16/9]";
  let t6;
  if ($[4] !== t5) {
    t6 = cn("grid w-full place-items-center overflow-hidden rounded-md border border-dashed bg-muted/30 text-sm text-muted-foreground transition-colors enabled:hover:bg-muted/60", t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = file ? file.path || file.filename : "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0438\u0437 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432";
  let t8;
  if ($[6] !== file || $[7] !== jobId) {
    t8 = file ? <ImportThumb jobId={jobId} fileId={file.id} className="size-full rounded-none" /> : <span className="flex flex-col items-center gap-1 p-2 text-center text-xs"><ImagePlus className="size-5" />Выбрать</span>;
    $[6] = file;
    $[7] = jobId;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== onPick || $[10] !== t4 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
    t9 = <button type="button" onClick={onPick} disabled={t4} className={t6} title={t7}>{t8}</button>;
    $[9] = onPick;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== editable || $[16] !== file || $[17] !== label || $[18] !== onClear) {
    t10 = file && editable && <Button type="button" variant="outline" size="icon-xs" className="absolute top-1 right-1" aria-label={`Убрать: ${label.toLowerCase()}`} onClick={onClear}><X /></Button>;
    $[15] = editable;
    $[16] = file;
    $[17] = label;
    $[18] = onClear;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t3 || $[22] !== t9) {
    t11 = <div className={t3}>{t9}{t10}</div>;
    $[20] = t10;
    $[21] = t3;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t1 || $[25] !== t11) {
    t12 = <div className="min-w-0 space-y-1.5">{t1}{t11}</div>;
    $[24] = t1;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}